<template>
  <CookiesInfo />
</template>

<script>
import CookiesInfo from '@/components/common/cookies/CookiesInfo.vue'

export default {
  name: 'Cookies',
  components: { CookiesInfo }
}
</script>

<style scoped>

</style>
